<template>
<div class="bk-gray-dark trick-1">
  <img src="../../../assets/images/preparare-formule/truc1.png" alt="/">
    <p>1. Ai grijă ca formula de lapte praf preparată să fie proaspătă</p>
    <span>Întotdeauna prepară formula de lapte chiar înainte de masă și pentru o singură porție, astfel încât să fie proaspătă de fiecare dată. Nu păstra laptele preparat pentru o perioadă mai lungă de 1 oră, deoarece își poate schimba proprietățile nutritive.</span>
</div>
</template>

<script>
export default {
    name: 'Prospetime',

    data() {
        return {}
    },
}
</script>
<style lang="scss" scoped>

.trick-1 p{
  margin-top: 50px;
  color: #17479E;
  font-size: 20px;
  font-weight: 600;
}

.trick-1 span{
  font-size: 16px;
  color: #17479e;
}
.bk-blue-light {
    background: #F1F8FF;
    border-radius: 20px;
    padding-top: 65px;
    width: 420px !important;
    min-height: 380px;
    max-height: 380px;
    position: relative;
    @media only screen and (max-width: 992px) {
        width: 100% !important;
        max-height: 100%;
        min-height: auto;
        padding-top: 45px;
    }

    p {
        font-size: 16px;
        font-weight: 600;
        color: #029FE3;
    }

    span {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
    }
}

.trick-1 img{
    position: absolute;
    left: 20px;
    top: -60px;
}

@media screen and (max-width: 526px){
  .trick-1 img{
    width: 89px !important;
    height: 89px !important;
    top: -40px;
  }
}

</style>
